<div class="flex flex-col items-center justify-center px-6 py-16 text-center">
    <div
        class="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-50 dark:bg-red-900/20">
        <i class="pi pi-exclamation-circle text-2xl text-red-400"></i>
    </div>
    <h3 class="mb-1 text-lg font-semibold text-gray-700 dark:text-gray-300">
        Oops!
    </h3>
    <p class="mb-6 max-w-xs text-sm text-gray-500 dark:text-gray-400">
        {{ message() }}
    </p>
    <button
        pButton
        [label]="retryLabel()"
        class="p-button-sm p-button-outlined"
        (click)="retry.emit()"></button>
</div>
